module.exports = __webpack_public_path__ + "static/media/profilePic.cde7e6f4.png";